import React from 'react';
import { MessageCircle } from 'lucide-react';
import { trackButtonClick } from '../utils/analytics';

const WhatsAppWidget = () => {
  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '+919829055959';
  const message = encodeURIComponent('Hi, I would like to know more about TallyBharat services.');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

  const handleClick = () => {
    trackButtonClick('whatsapp_widget', 'floating_widget');
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 left-6 z-40 bg-[#25D366] hover:bg-[#20BA5A] text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 group animate-in slide-in-from-left-4"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={28} className="group-hover:rotate-12 transition-transform" />
      
      {/* Tooltip */}
      <span className="absolute left-full ml-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Chat on WhatsApp
      </span>
    </button>
  );
};

export default WhatsAppWidget;